import React, { useEffect, useState } from "react";
import LaunchpadComponent from "./LaunchpadComponent";
import {
  _InfinityFactoryContractGetAllDataByAddress,
  _IDOSaleTotalCollectedFunds,
} from "../../Services/Web3Connection";
import Pagination from "../Pagination";
import Loading from "../Animation/Loading/Loading";
import Search from "../Search/Search";

export default function LaunchpadList(props) {
  const [FactoryContract, setFactoryContract] = useState(null);
  const [searchData, setSearchData] = useState(null);
  const [showPerPage, setshowPerPage] = useState(6);
  const [totalContent, settotalContent] = useState(1);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });
  useEffect(async () => {
    let data = await _InfinityFactoryContractGetAllDataByAddress();
    setFactoryContract(data);
    settotalContent(data.length);
  }, []);

  const onPaginationsChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  return (
    <>
      {/* <Search Data={FactoryContract} /> */}
      {FactoryContract === null ? (
        <div
          style={{
            color: "#ff832e",
            textAlign: "center",
            position: "relative",
          }}
        >
          <Loading />
        </div>
      ) : (
        <>
          {/* <Search Data={FactoryContract} /> */}
          <div className="container cardlist">
            {FactoryContract.slice(pagination.start, pagination.end)
              .map((data, key) => <LaunchpadComponent key={key} data={data} />)
              .reverse()}
          </div>
        </>
      )}
      {/* <Pagination
        showPerPage={showPerPage}
        onPaginationsChange={onPaginationsChange}
        totalContent={totalContent}
      /> */}
    </>
  );
}

const Data = [
  {
    status: "Upcoming",
    url: "/launchpad/upcoming",
  },
  {
    status: "Active",
    url: "/launchpad/active",
  },
  {
    status: "Ended",
    url: "/launchpad/ended",
  },
];
